/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import { Breakpoint } from 'react-socks';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import { Link } from 'react-router-dom';
import * as _ from 'underscore';
import PostAnalysisModal from 'app/components/CreateFeed/PostAnalysisModal.jsx';
import ReuseSocialInputModal from 'app/components/InputModal/ReuseSocialInputModal.jsx';
import FeatureCallout from 'app/components/common/FeatureCallout.jsx';
import { assetBase } from '@/lib/asset-base.ts';
import {
    MORE_SOURCES,
    PRIMARY_SOURCES,
    SourceStep
} from '@/shadcn/components/NewAutomation/SourceStep.tsx';

class ChooseFeedType extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            subTilesVisible: false,
            externalServiceClicked: false,
        };

        this.socialRef = React.createRef();

        this.onTileClick = this.onTileClick.bind(this);
        this.oauthConnector = this.oauthConnector.bind(this);
        this.onSourceSelect = this.onSourceSelect.bind(this);

    }

    componentDidMount() {
        let onboarding = (typeof(Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null,
            isOnboarding = (onboarding === null) ? false : true,
            constants = this.props.app.config.constants;


        if (this.props.recordEvent) {
            this.props.recordEvent({
                pub_id: this.props.user.detail.id,
                event_name: 'Input Tiles View'
            });
        }

        if (dataLayer) {
            dataLayer.push({
                'event': 'input-tiles-view',
                'onboarding': isOnboarding
            });
        }

        if (this.props.router.params && this.props.router.params.inputType !== undefined) {
            let type = 0,
                subType = 0,
                crossPostType = 0;

            switch (this.props.router.params.inputType) {
                case "feed":
                    type = 'feed_search_tile';
                    break;

                case "instagram":
                    type = 'cross_post';
                    crossPostType = constants.INPUT_TYPE_INSTAGRAM_BUSINESS;
                    break;

                case "facebook":
                    type = 'cross_post';
                    crossPostType = constants.INPUT_TYPE_FACEBOOK_PAGE;
                    break;

                case "tiktok":
                    type = 'cross_post';
                    crossPostType = constants.INPUT_TYPE_TIKTOK;
                    break;

                case "youtube":
                    type = "cross_post";
                    crossPostType = constants.INPUT_TYPE_YOUTUBE;
                    break;

                case "pinterest":
                    subType = constants.INPUT_SUBTYPE_PINTEREST;
                    break;

                default:
                    break;
            }

            this.onTileClick({
                currentTarget: {
                    dataset: {
                        type: type,
                        subtype: subType,
                        crossPostType: crossPostType,
                        oauth: false
                    }
                }
            });
        }

        if (this.props.router.query && this.props.router.query.social !== undefined && this.props.router.query.social === "true") {
            this.onTileClick({
                currentTarget: {
                    dataset: {
                        type: 'cross_post',
                        subType: 0,
                        oauth: false
                    }
                }
            });
            //window.scrollTo(0, this.socialRef.current.offsetTop);
        }

        if (this.props.router.query && this.props.router.query.feed !== undefined && this.props.router.query.feed === "true") {
            this.onTileClick({
                currentTarget: {
                    dataset: {
                        type: 'feed_search_tile',
                        subType: 0,
                        oauth: false
                    }
                }
            });

        }

    }

    oauthConnector(service, input) {
        let url = '/remote/begin?fx=auth&isID=:isId&state=:state&final=:final',
            date = new Date(),
            state = ['INPUT', service, date.getTime()].join('_'),
            constants = this.props.app.config.constants;

        if (input && input.sysActionFlag) {
            if (input.iID !== undefined && input.iID) {
                url = `/remote/beginreauth?isID=${input.iType}&iaID=${input.iID}&state=:state&final=:final`;
                state = ['REAUTHREUSE', input.iType, input.iID, service, date.getTime()].join('_');
            } else if (input.paID !== undefined && input.paID) {
                url = `/remote/beginreauth?psID=${input.paSvcID}&paID=${input.paID}&state=:state&final=:final`;
                state = ['REAUTHREUSE', input.paSvcID, input.paID, service, date.getTime()].join('_');
            }

        } else {
            url = url.replace(':isId', service);
        }

        if (service == constants.INPUT_TYPE_TWITTER) {
            if (this.props.user.perms.resources.inputTwitter === 0) {
                this.props.showUpgradeModal(this.props.closeAllModals, 'twitterInput', null, this.props.context + '_create');
                return;
            }
        }

        url = url.replace(':state', state);
        let finalUrl = this.props.cleanUrl(window.location.href);
        url = url.replace(':final', window.encodeURIComponent(finalUrl));

        window.location.assign(url);

    }

    /*
     * The new source step (shadcn/NewAutomation/SourceStep) names each source by
     * a slug; this flow names them by the numeric INPUT_TYPE_* / INPUT_SUBTYPE_*
     * codes, plus a few string pseudo-types. This is the bridge.
     *
     * It returns onTileClick's `dataset` rather than calling the redux actions
     * itself, so the new tiles go through exactly the same path as the legacy
     * ones — the entitlement gates, the analytics events, the OAuth handoff and
     * the ReuseSocialInputModal all keep working with no second copy to drift.
     *
     * `oauth` is the string "true" because onTileClick compares it as one, and
     * `wordpress` is a type rather than a subtype to match the shape
     * tileGenerator hands over for that tile.
     */
    sourceDataset(network) {
        let constants = this.props.app.config.constants,
            map = {
                rss:       {type: 'website_tile'},
                instagram: {type: constants.INPUT_TYPE_INSTAGRAM_BUSINESS, oauth: 'true'},
                facebook:  {type: constants.INPUT_TYPE_FACEBOOK_PAGE, oauth: 'true'},
                tiktok:    {type: constants.INPUT_TYPE_TIKTOK, oauth: 'true'},
                youtube:   {type: constants.INPUT_TYPE_YOUTUBE, oauth: 'true'},
                pinterest: {subtype: constants.INPUT_SUBTYPE_PINTEREST},
                wordpress: {type: 'wordpress'},
                etsy:      {subtype: constants.INPUT_SUBTYPE_ETSY},
                shopify:   {subtype: constants.INPUT_SUBTYPE_SHOPIFY},
                substack:  {subtype: constants.INPUT_SUBTYPE_SUBSTACK}
            },
            entry = map[network];

        if (entry === undefined) {
            return null;
        }

        return {
            type: (entry.type !== undefined) ? entry.type : 0,
            subtype: (entry.subtype !== undefined) ? entry.subtype : 0,
            crossPostType: 0,
            oauth: (entry.oauth !== undefined) ? entry.oauth : false
        };
    }

    onSourceSelect(network) {
        let dataset = this.sourceDataset(network);

        if (dataset === null) {
            return;
        }

        this.onTileClick({
            currentTarget: {dataset: dataset}
        });
    }

    onTileClick(e) {
        let type = parseInt(e.currentTarget.dataset.type, 10),
            subtype = parseInt(e.currentTarget.dataset.subtype, 10),
            crossPostType = parseInt(e.currentTarget.dataset.crossPostType, 10),
            oauth = e.currentTarget.dataset.oauth,
            code = (subtype) ? subtype : type,
            serviceName = '',
            onboarding = (typeof(Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null,
            isOnboarding = (onboarding === null) ? false : true,
            constants = this.props.app.config.constants;

        if (this.state.externalServiceClicked) {
            return;
        }

        if (isNaN(crossPostType)) {
            crossPostType = 0;
        }

        // clear out any previous validation errors when a new tile is clicked
		this.props.deleteApiError(['INPUT_VALIDATE', 'FEED_SEARCH', 'FEED_VALIDATE']);

        if (isNaN(type) && e.currentTarget.dataset.type === 'wordpress') {
            type = 'wordpress';
        } else if (isNaN(type) && e.currentTarget.dataset.type === 'feed_search_tile') {
            type = 'feed_search_tile';
        } else if (isNaN(type) && e.currentTarget.dataset.type === 'website_tile') {
            type = 'website_tile';
        } else if (isNaN(type) && e.currentTarget.dataset.type === 'create_post') {
            type = 'create_post';
        } else if (isNaN(type) && e.currentTarget.dataset.type === 'cross_post') {
            type = 'cross_post';
        } else if (isNaN(type) && e.currentTarget.dataset.type === 'post_analyzer') {
            type = 'post_analyzer';
        } else if (isNaN(type) && e.currentTarget.dataset.type === 'ai_helper') {
            type = 'ai_helper';
        }

        // TODO: remove the post_analysis check when it's real
        if (this.props.user.perms.resources.inputsAvailable === 0 && type !== 'post_analyzer') {
			this.props.showUpgradeModal(this.props.closeAllModals, 'inputs', null, 'Input Tiles');
            return;
		}

        serviceName = ConstantMixin.getInputServiceByCode(code);

        if (type === 'wordpress') {
            serviceName = 'wordpress';
        } else if (type === 'feed_search_tile') {
            serviceName = 'feed_search_tile';
        } else if (type === 'website_tile') {
            serviceName = 'website_tile';
        } else if (type === 'create_post') {
            serviceName = 'create_post';
        } else if (type === 'cross_post') {
            serviceName = 'cross_post';
        } else if (type === 'ai_helper') {
            serviceName = 'ai_helper';
        }

        if (this.props.recordEvent) {
            this.props.recordEvent({
                pub_id: this.props.user.detail.id,
                event_name: 'Input Tiles Click',
                event_data: {
                    service: serviceName
                }
            });
        }

        if (dataLayer) {
            dataLayer.push({
                'event': 'input-tiles-click',
                'onboarding': isOnboarding,
                'service': serviceName
            });
        }

        if (type === constants.INPUT_TYPE_TWITTER) {
            if (this.props.user.perms.resources.inputTwitter === 0) {
                this.props.showUpgradeModal(this.props.closeAllModals, 'twitterInput', null, 'Input Tiles');
                return;
            }
        }

        if (e.preventDefault) {
            e.preventDefault();
        }

        if (oauth === "true") {
            if (this.props.automatedRoutes.socialInputCreds[type] !== undefined && this.props.automatedRoutes.socialInputCreds[type].length) {
                this.props.addModal(
                    <ReuseSocialInputModal
                        {...this.props}
                        service={type}
                        credList={this.props.automatedRoutes.socialInputCreds[type]}
                        newConnection={this.oauthConnector}
                        />
                );
            } else {
                this.oauthConnector(type);
                this.setState({
                    externalServiceClicked: true
                });
            }


        } else if (type === 'create_post') {
            this.props.router.navigate("/content/post");
        } else if (type === 'ai_helper') {
            this.props.router.navigate("/content/post?helper");
        } else if (_.isFunction(this.props.inputSelectCallback)) {
            this.props.inputSelectCallback(type, subtype, crossPostType);
        }

    }

    render() {
        if (this.props.tile) {
            return this.renderStep();
        }

        return this.renderTiles();
    }

    /*
     * The new-design source step. Only the artwork changes: selection still runs
     * through onTileClick, so every gate and side effect above applies.
     *
     * `crossPostType` arrives from a deep link that already picked a network, so
     * that mode shows only the matching card and hides the disclosure — the same
     * narrowing the legacy tiles do with `_.where(types, {type: crossPostType})`.
     *
     * Both lists are searched, unlike the legacy narrowing, which looks only at
     * the four featured tiles. YouTube is a cross-post target but sits under
     * "more sources", so `?inputType=youtube` matched nothing there and drew an
     * empty step with the disclosure already hidden — no way forward but Back.
     */
    renderStep() {
        let base = assetBase(this.props.app.config),
            primary = PRIMARY_SOURCES,
            showMore = true;

        if (this.props.crossPostType) {
            primary = PRIMARY_SOURCES.concat(MORE_SOURCES).filter((spec) => {
                let dataset = this.sourceDataset(spec.network);
                return dataset !== null && dataset.type === this.props.crossPostType;
            });
            showMore = false;
        }

        return (
            <SourceStep
                base={base}
                primarySources={primary}
                moreSources={MORE_SOURCES}
                showMore={showMore}
                onSelect={this.onSourceSelect} />
        );
    }

    renderTiles() {
        let constants = this.props.app.config.constants,
            imgPath = this.props.app.config.assetsUrl + "/" + this.props.app.config.imageUrl,
            onboarding = (typeof(Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null,
            types = [
                {label: 'RSS Feed', type: 'website_tile', logo: imgPath + 'svg-logos/feed.svg', oauth: false, alt: "Search for website content", extraClass: 'featured', desc: 'Website / Blog'},
                {label: 'Instagram', type: constants.INPUT_TYPE_INSTAGRAM_BUSINESS, logo: imgPath + 'svg-logos/instagram-color-icon.svg', oauth: true, alt: "Create Instagram Feed", extraClass: 'featured', desc: 'Professional'},
                {label: 'Facebook', type: constants.INPUT_TYPE_FACEBOOK_PAGE, logo: imgPath + 'svg-logos/facebook.svg', oauth: true, alt: "Create Facebook Page Feed", extraClass: 'featured', desc: 'Page'},
                {label: 'TikTok', type: constants.INPUT_TYPE_TIKTOK, logo: 'ds-icon icon-tiktok', oauth: true, alt: "Create TikTok Feed", extraClass: 'featured', desc: 'Profile'},
            ],
            subTypes = [
                {label: 'YouTube', type: constants.INPUT_TYPE_YOUTUBE, logo: imgPath + 'svg-logos/YouTube-grey.svg', oauth: true, alt: "Create YouTube Feed", extraClass: 'subtype'},
                {label: 'Pinterest', subtype: constants.INPUT_SUBTYPE_PINTEREST, logo: imgPath + 'svg-logos/Pinterest-grey.svg', oauth: false, alt: "Create Pinterest Feed", extraClass: 'subtype'},
                {label: 'WordPress', subtype: 'wordpress', logo: imgPath + 'svg-logos/Wordpress-grey.svg', oauth: false, alt: "Search Your WordPress Site", extraClass: 'subtype'},
                {label: 'Etsy', subtype: constants.INPUT_SUBTYPE_ETSY, logo: imgPath + 'svg-logos/Etsy-grey.svg', oauth: false, alt: "Create Etsy Feed", extraClass: 'subtype'},
                {label: 'Shopify', subtype: constants.INPUT_SUBTYPE_SHOPIFY, logo: imgPath + 'svg-logos/shopify-grey.svg', oauth: false, alt: "Create Shopify Feed", extraClass: 'subtype'},
                {label: 'Substack', subtype: constants.INPUT_SUBTYPE_SUBSTACK, logo: imgPath + 'svg-logos/Substack-grey.svg', oauth: false, alt: "Create Substack Feed", extraClass: 'subtype'},
            ],
            tileGenerator = (type) => {
                let dataType = (type.type) ? type.type : 0,
                    dataSubtype = (type.subtype) ? type.subtype : 0,
                    icon = null,
                    flair = null;

                if (type.logo.match(/icon-|fa\b/)) {
                    icon = (
                        <i className={`${type.logo} tile-icon`}></i>
                    );
                } else {
                    if (dataType && dataType !== constants.INPUT_TYPE_YOUTUBE) {
                        icon = (
                            <img src={type.logo} width="35" height="35"/>
                        );
                    } else {
                        icon = (
                            <img src={type.logo} width="auto" height="24"/>
                        );
                    }

                }

                if (type.flair !== undefined && type.flair === true) {
                    flair = (
                        <div className="flair">
                            <i className="fa fa-star"/>
                        </div>
                    );
                }

                if (dataType || dataSubtype === "wordpress") {
                    // dumb hack for time
                    if (dataSubtype === "wordpress") {
                        dataType = "wordpress";
                        dataSubtype = "";
                    }
                    return (
                        <div key={[type.label.replace(" ", ""), dataType, dataSubtype].join("-")}
                                alt={type.alt}
                                className={"input-tile " + type.extraClass}
                                data-type={dataType} data-subtype={dataSubtype}
                                data-oauth={type.oauth}
                                onClick={this.onTileClick}
                                role="button"
                                aria-label={type.alt}>
                            {flair}
                            <div className="tile-img">
                                {icon}
                            </div>
                            <div className="tile-label">
                                {type.label}
                            </div>
                            <div className="tile-desc">
                                {type.desc}
                            </div>
                        </div>
                    );
                } else {
                    return (
                        <div key={[type.label.replace(" ", ""), dataType, dataSubtype].join("-")}
                                alt={type.alt}
                                className={"input-tile " + type.extraClass}
                                data-type={dataType} data-subtype={dataSubtype}
                                data-oauth={type.oauth}
                                onClick={this.onTileClick}
                                role="button"
                                aria-label={type.alt}>
                            {flair}
                            <div className="tile-img">
                                {icon}
                            </div>
                            <div className="tile-label">
                                {type.label}
                            </div>
                        </div>
                    );
                }


            },
            content = null,
            chevron = null;


        if (this.state.subTilesVisible) {
            chevron = (
                <i className="icon ion-chevron-up social-tiles-accordion"></i>
            );
        } else {
            chevron = (
                <i className="icon ion-chevron-down social-tiles-accordion"></i>
            );
        }

        let moreOptions = null;
        if (!this.props.crossPostType) {
            moreOptions = (
                <div>
                    <div className="more-options" onClick={() => {
                        let nextSubTilesVisible = this.state.subTilesVisible ? false : true;
                        this.setState({
                            subTilesVisible: nextSubTilesVisible
                        });
                    }}>
                        more options {chevron}
                    </div>
                    {(this.state.subTilesVisible) ? (
                        <div className="tile-wrapper">
                            {subTypes.map((type) => {
                                return tileGenerator(type);
                            })}
                        </div>
                    ) : null}
                </div>
            )
        }

        let displayTypes = [...types];
        if (this.props.crossPostType) {
            displayTypes = _.where(types, {type: this.props.crossPostType});
        }

        content = (
            <div>
                <div className="feed-chooser-wrapper">
                    <div className="tile-wrapper">
                        {displayTypes.map((type) => {
                            return tileGenerator(type);
                        })}
                    </div>
                    {moreOptions}
                </div>

            </div>
        );

        return content;

    }
}

ChooseFeedType.displayName = "ChooseFeedType";

ChooseFeedType.propTypes = {
    inputType: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),
    inputSelectCallback: PropTypes.func,
    /** Renders the new-design source step instead of the legacy tiles. */
    tile: PropTypes.bool
};

ChooseFeedType.defaultProps = {
    inputType: 0,
    inputSelectCallback: null,
    tile: false
};

export default ChooseFeedType;
